var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"boy_warp"},[_c('el-card',{staticStyle:{"height":"100%"}},[_c('p',[_vm._v("集体户每户人员数量占比情况")]),_c('div',{ref:"echartsINof",staticStyle:{"height":"100%"}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }